import { useEffect } from 'react'

const preventDefault = (e: TouchEvent) => e.preventDefault()

export const usePreventScroll = (isDragging: boolean) => {
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('touchmove', preventDefault, { passive: false })
    } else {
      document.removeEventListener('touchmove', preventDefault)
    }
    return () => {
      document.removeEventListener('touchmove', preventDefault)
    }
  }, [isDragging])
}
